<template>
    <div>
        <buttonlist
                @help="help"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo">
            <el-tab-pane :label="$t('getapi[1977]')" name="0" id="xpane-0">
                <vxe-table :data="dataSet.dt" size="mini" :loading="loading" :height="tableHeight" stripe border
                           resizable
                           ref="singleTable">
                    <vxe-table-column show-footer-overflow v-for="item in dataSet.header"
                                      :key="item.Headen"
                                      :field="item.Headen"
                                      :title="item.Headcn"
                                      :align="item.Headen == '标准成本' || item.Headen =='单价' || item.Headen =='数量' || item.Headen =='PPV'?'right':'left'"
                                      width="150px"
                    >
                        <template scope="scope" >
                            <span v-if="item.Headen == '标准成本' || item.Headen =='单价' || item.Headen =='PPV'">{{ scope.row[item.Headen] | thousandthpurprice}}</span>
                            <span v-else>{{ scope.row[item.Headen]}}</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight - 60"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[112]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[149]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[3709]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[3710]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="issue_dept" :label="$t('getapi[3854]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[1972]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[1287]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[1167]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[876]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[1973]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[1410]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[1628]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="keep_person" label="PPV"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[1974]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[1975]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[1976]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" label="采购件类型"></el-table-column>
                </el-table>-->
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[1978]')" name="1" id="xpane-1">
                <vxe-table :data="dataSet1.dt" size="mini" :loading="loading" :height="tableHeight" stripe border
                           resizable
                           ref="singleTable1">
                    <vxe-table-column show-footer-overflow v-for="item in dataSet1.header"
                                      :key="item.Headen"
                                      :field="item.Headen"
                                      :title="item.Headcn"
                                      width="150px"
                    ></vxe-table-column>
                </vxe-table>
                <!--<el-table
                        :data="dataSet1"
                        ref="singleTable1"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight - 60"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[3728]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[1861]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="issue_dept" :label="$t('getapi[2180]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[3690]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[4583]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4584]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4585]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[1747]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[1864]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[2203]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                </el-table>-->
            </el-tab-pane>
        </el-tabs>
        <!--<el-row v-if="SelectIndex == 0">
            <el-col :span="18">
                <el-pagination
                        style="margin-top: 1em"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>-->
        <!--<el-row v-if="SelectIndex == 1">
            <el-col :span="18">
                <el-pagination
                        style="margin-top: 1em"
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>-->
        <serce :isVisible="isVisible0" queryData="PPVPurReceiveViewInfo" ref="ser0" @getser="serclick"></serce>
        <serce :isVisible="isVisible1" queryData="PPVISSReceiveInViewInfo" ref="ser1" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'ppvview',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3 - Common.reduceTableHeight2
            }
        },
        data() {
            return {
                isVisible0: false, // 查询列表是否显示
                isVisible1: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: {
                    header: [],
                    dt: []
                },
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                loading: false, // 主表加载状态
                dataSet1: {
                    header: [],
                    dt: []
                }, // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: 50, // 当前页数据量
                total1: 0, // 数据总量
                scrollTop:0,
                scrollTop1:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
            dataSet1: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(1)
                    }, 500);
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[968]"),this.$t("getapi[16]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                if (that.$limits.authority('plv2', 70, 1) == 1) {
                    //只读权
                    if ((that.dataSet.dt.length > 0 && that.SelectIndex == 0) || (that.dataSet1.dt.length > 0 && that.SelectIndex == 1)) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                if (that.$limits.authority('plv2', 70, 1) == 2) {
                    if (that.$limits.authority('plv3', 70, 1) == 0) {
                        if ((that.dataSet.dt.length > 0 && that.SelectIndex == 0) || (that.dataSet1.dt.length > 0 && that.SelectIndex == 1)) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 70, 1) == 1) {
                        //编辑级
                        if ((that.dataSet.dt.length > 0 && that.SelectIndex == 0) || (that.dataSet1.dt.length > 0 && that.SelectIndex == 1)) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                    if (that.$limits.authority('plv3', 70, 1) == 2) {
                        //删除级
                        if ((that.dataSet.dt.length > 0 && that.SelectIndex == 0) || (that.dataSet1.dt.length > 0 && that.SelectIndex == 1)) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.authority();
                that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });
            },
            // 查询
            search() {
                let that = this;
                if (that.SelectIndex == 0) {
                    that.isVisible0 = true;
                    that.$refs.ser0.clearInput(that.isVisible0, 'PPVPurReceiveViewInfo');
                } else {
                    that.isVisible1 = true;
                    that.$refs.ser1.clearInput(that.isVisible1, 'PPVISSReceiveInViewInfo');
                }
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Statistics/GetPPVPurReceiveView', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        } else if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        }
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }that.loading = false;
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[2089]')
                };
                if(that.SelectIndex == 1){
                    parm.fromname = that.$t('getapi[2090]')
                }
                that.$http.urlpost('/Pur/Statistics/GetPPVPurReceiveToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
